import React from "react";
import { Link } from "react-router-dom";
import { FaTwitter, FaInstagram, FaGithub, FaArrowUp } from "react-icons/fa";
import { animateScroll as scroll } from "react-scroll";

export default function Footer() {
  return (
    <footer className="footer" id="footer">
      <div className="footer__container">
        <div className="footer__top">
          <div
            className="footer__logo"
            onClick={() => scroll.scrollToTop()}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && scroll.scrollToTop()}
          >
            AR<span>.</span>
          </div>
          <p className="footer__tagline">
            Building clean, scalable software — one commit at a time.
          </p>
          <div className="footer__socials">
            <a
              href="https://twitter.com/alexbyrod"
              aria-label="Twitter"
              target="_blank"
              rel="noreferrer"
            >
              <FaTwitter />
            </a>
            <a
              href="https://www.instagram.com/alexbyrod_7"
              aria-label="Instagram"
              target="_blank"
              rel="noreferrer"
            >
              <FaInstagram />
            </a>
            <a
              href="https://github.com/Sterki"
              aria-label="GitHub"
              target="_blank"
              rel="noreferrer"
            >
              <FaGithub />
            </a>
          </div>
        </div>

        <div className="footer__bottom">
          <p>© {new Date().getFullYear()} Alex Rodriguez. All rights reserved.</p>
          <nav className="footer__legal" aria-label="Legal">
            <Link to="/impressum">Impressum</Link>
            <Link to="/datenschutz">Datenschutz</Link>
          </nav>
          <button
            className="footer__scroll-top"
            onClick={() => scroll.scrollToTop()}
            aria-label="Scroll to top"
          >
            Back to top <FaArrowUp />
          </button>
        </div>
      </div>
    </footer>
  );
}
